
function getUrlParts(url) {
    const re = /((https?:)\/\/([.a-zA-Z0-9-]+)(:([0-9]+))?)?(\/(([.+a-zA-Z0-9_-]+\/?)?)+)?(\?[^#]+)?/;
    const matches = re.exec(url);

    return {
        url,
        protocol: matches[2],
        host: matches[3],
        port: matches[4] || '',
        pathname: matches[6] || '',
        search: matches[9],
    };
}

function isSameOrigin(url) {
    const { host, protocol, port } = getUrlParts(url);
    return host === document.location.host && protocol === document.location.protocol && port === document.location.port;
}

const domCacheHandler = {
    name: 'domCacheHandler',
    async fetchFile(fileInfo) {
        let init;

        if (isSameOrigin(fileInfo.url)) {
            init = {
                credentials: 'same-origin',
                cache: 'reload',
                destination: 'image',
                redirect: 'follow',
            };
        } else {
            init = {
                mode: 'no-cors',
                credentials: 'omit',
            };
        }

        return fetch(fileInfo.url, init);
    },

    async loadPackageFile(fileInfo) {
        const { url } = fileInfo;
        return this.fetchFile(fileInfo)
            .catch((error) => {
                console.log(error, url);
            });
    },

    async cacheSingleFile(fileModel) {
        return this.loadPackageFile(fileModel)
            .then(() => {
                return { success: true, cacheStatus: 'added_to_cache' };
            })
            .catch((error) => {
                return { success: false, cacheStatus: 'not_cached', error };
            })
            .then((fileResult) => {
                return { fileModel, ...fileResult };
            });
    },

    async cacheFilePackage(filePackage) {
        const responsePkg = JSON.parse(JSON.stringify(filePackage));
        const resultFiles = [];

        await Promise.all(responsePkg.files.map(fileModel => this.cacheSingleFile(fileModel)));

        responsePkg.files = resultFiles;
        responsePkg.success = responsePkg.files.every(fileInfo => fileInfo.success === true);
        return responsePkg;
    },

    abortResourceLoading() {
        console.warn('Abort is not implemented for domCacheHandler');
    },

    async deleteCachesForOtherAssessments() {
        return Promise.resolve();
    },

    async deleteAssessmentDataCache() {
        return Promise.resolve();
    },

    async deleteAllAssessmentDataCaches() {
        return Promise.resolve();
    },
};

export default domCacheHandler;
